import React from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';
import { i18n } from '../../../../../symphony';

import s from './WhatYouLearn.scss';
import { ILPWhatYouLearnData, ILearnThemeItem } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

interface IWhatYouLearnProps {
	data: ILPWhatYouLearnData;
	alias: string;
}

export function WhatYouLearn({ data, alias }: IWhatYouLearnProps): JSX.Element {
	useStyles(s);
	const { imgUrl, themes } = data;
	return (
		<section className="lp-what-you-learn">
			<div className="lp-what-you-learn__wrapper">
				<div className="lp-what-you-learn__content">
					<div>
						<h2 className="lp-what-you-learn__title">
							{i18n.t(`web-lelp.${alias}-what-you-learn-title`)}
						</h2>
						<div className="lp-what-you-learn__themes-block">
							{themes.map(({ id }: ILearnThemeItem, index) => (
								<div
									className="lp-what-you-learn__theme-card"
									key={id}
								>
									<div className="lp-what-you-learn__theme-title">
										{i18n.t(
											`web-lelp.${alias}-what-you-learn-item${index}-title`,
										)}
									</div>
									<div className="lp-what-you-learn__theme-text">
										{i18n.t(
											`web-lelp.${alias}-what-you-learn-item${index}-description`,
										)}
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="lp-what-you-learn__image">
						<img src={imgUrl} alt="illustration" />
					</div>
				</div>
			</div>
		</section>
	);
}
